module.exports = __webpack_public_path__ + "static/media/iconShortQuestion.b08b73e0.svg";